export default function setTooltipTitleByWidth(ref, title) {
    if (!ref.current) return;
    if (ref.current.offsetWidth < ref.current.scrollWidth) {
        ref.current.title = title;
    } else {
        ref.current.title = '';
    }
}